import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';

@Component({
  selector: 'app-pagos-cliente-formas-pago',
  templateUrl: './formas-pago.component.html',
  styleUrls: ['./formas-pago.component.scss'],
})
export class FormasPagoComponent implements OnInit {
  @Output() onSaldo = new EventEmitter();

  // Utils
  formasPagoData: any = null;
  diferencial_a_pagar: number = 0;
  enabled: boolean = false;
  private log: any;

  MontoPagar: number = 0; //MONTO PAGO
  SaldoPago: number = 0; // DIFERENCIAL - MONTO

  constructor(private clog: ConsoleService, private toastrService: ToastService) { }

  ngOnInit() {
    this.log = this.clog.log('REALIZAR-PAGOS-FORMAS-PAGO');
  }

  loadData(data, diferencial_a_pagar: number) {
    this.formasPagoData = data;
    this.diferencial_a_pagar = diferencial_a_pagar;
    this.formasPagoData.forma_pago.map((formaPago, index) => {
      formaPago.checked = false;
      formaPago.index = index;
      formaPago.monto = Number(formaPago.monto.toString().replace(/\./g, ''));
    });
    this.enabled = true;
    console.log('quiero ver plss', this.formasPagoData);
    this.formasPagoData.total_forma_pago = _.sumBy(this.formasPagoData.forma_pago, 'monto');
    console.log(this.formasPagoData.total_forma_pago);

    this.SaldoPago = this.diferencial_a_pagar;

    this.SaldoPago = this.diferencial_a_pagar - this.formasPagoData.total_forma_pago;
    console.log(this.diferencial_a_pagar);
    console.log(this.SaldoPago);

    console.log(this.formasPagoData.total_forma_pago);
    if (Math.sign(this.SaldoPago) == -1) {
      this.onSaldo.emit(0);
    } else {
      this.onSaldo.emit(this.SaldoPago);
    }
  }

  checkAllPagos({ checked }) {
    this.formasPagoData.forma_pago.forEach((forma_pago) => {
      forma_pago.checked = checked;
    });
  }

  checkPago({ index }) {
    const selected = this.formasPagoData.forma_pago.filter((forma_pago) => forma_pago.index === index)[0];
    selected.checked = !selected.checked;
  }

  eliminarPagos() {
    const selected = this.formasPagoData.forma_pago.filter((forma_pago) => forma_pago.checked);
    if (selected.length === 0) {
      this.toastrService.warning('Seleccione una forma de pago');
      return;
    }
    this.formasPagoData.forma_pago = this.formasPagoData.forma_pago.filter((forma_pago) => !forma_pago.checked);
    this.toastrService.success('Pagos eliminados');

    //TODO:
    // Qué sucederá con los totales
    this.formasPagoData.total_forma_pago = Number(_.sumBy(this.formasPagoData.forma_pago, 'monto'));
    this.formasPagoData.diferencial_pago = this.diferencial_a_pagar - this.formasPagoData.total_forma_pago;

    this.sumaFormaPago();
  }

  getPagosData(data) {
    this.log(data)
    if (data.monto_coforme > 0) {
      return _.cloneDeep(this.formasPagoData);
    } else {
      // Si el diferencial quedó en 0 porque se cubrió completamente con Pago a Cuenta / NC / excedente,
      // no debe mostrarse error; simplemente no habrá forma de pago manual.
      const difs = data && data.difereciaPago && Array.isArray(data.difereciaPago) ? data.difereciaPago : [];
      const cubiertoPorPagoCuenta = difs.some((p: any) => {
        if (p == null || typeof p !== 'object') return false;
        const utilizado = parseFloat(p.pago_cuenta_utilizado) || 0;
        return utilizado > 0;
      });

      if (!cubiertoPorPagoCuenta) {
        this.toastrService.error('El diferencial a pagar es 0. Intente cancelar y volver a intentarlo.', 'Monto diferencial es 0');
      }
      this.formasPagoData = data;
      this.formasPagoData.total_forma_pago = 0;
      this.formasPagoData.forma_pago = [];
      this.formasPagoData.diferencial_pago = data.diferencial_pago;
      return this.formasPagoData;
    }
  }

  clearData() {
    this.formasPagoData = null;
    this.enabled = false;
  }

  sumaFormaPago() {
    let valorinicial = 0;

    const val = this.formasPagoData.forma_pago.reduce((valoranterior, data) => valoranterior + data.monto, valorinicial);

    this.formasPagoData.total_forma_pago = val;

    this.SaldoPago = this.diferencial_a_pagar - this.formasPagoData.total_forma_pago;
    this.MontoPagar = this.SaldoPago;

    console.log(this.SaldoPago);
    console.log(this.diferencial_a_pagar);
    console.log(this.formasPagoData.total_forma_pago);
    console.log(this.MontoPagar);
    this.onSaldo.emit(this.SaldoPago);
  }
}
